import React, { useEffect, useState } from 'react'
import Text from '@components/Text';
import { css } from '@linaria/core';
import { styled } from '@linaria/react';
import { useDispatch } from 'react-redux';
import { themeDefault } from 'src/theme-revamp';

import Button from '@components/_Revamp/Button';
import Bullet from '@components/_Revamp/Bullet';
import { useHistory } from 'react-router-dom';
import Modal from '@components/_Revamp/Modal';
import BackModal from './components/BackModal';
import { updateEligible } from '@redux/slices/MLTC_R3/step2Slice';
import Accordion from '@components/_Revamp/Accordion';
import { useAvivaSelector } from '@redux/hook';
import { Helpers } from '@utils/helpers';
import { GAAviva, MLTC_R3_JOURNEY_NAME } from '@utils/gaAvivaR3';
import BottomSheet from '@components/_Revamp/BottomSheet';
import MaintenanceMessageBox from './components/MaintenanceMessageBox';
import MaintenanceModal from './components/MaintenanceModal';
import { get } from 'lodash';
import { UOB_CONTACT_URL } from '@static/config';


const Container = styled.div`
  position:relative;
  padding: 0 100px;
  margin: 150px auto;
  max-width: 1230px;
  display: block;
  flex-wrap: wrap;
  @media screen and (max-width: 1280px) {
    padding: 0 100px;
    margin: 150px auto 100px;
    max-width: 792px;
  }
  @media screen and (max-width: 768px) {
    padding: 0;
    // max-width: 588px;
  }
  @media screen and (max-width: 588px) {
    padding: 0;
    // max-width: 327px;
  }
`;
const DeclarationBulletsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  row-gap: 0px;
  @media screen and (max-width: 1280px) {
    padding: 0 0;
  }
  @media screen and (max-width: 768px) {
    padding: 0 0;
  }
`;

const HeaderTitleCss = css`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 28px;
  line-height: 140%;
  color: #434343;
  @media screen and (max-width: 768px) {
    font-size: 20px;
  }
`;
const FormContainer = styled.div<FormHeaderContainerProps>`
  max-width: ${props => props.maxWidth ? props.maxWidth : "unset"};  
  opacity: 1;
  -webkit-transition: opacity 0.5s ease-in;
  -moz-transition: opacity 0.5s ease-in;
  -o-transition: opacity 0.5s ease-in;
  -ms-transition: opacity 0.5s ease-in;
  transition: opacity 0.5s ease-in;
  flex-direction:column;
  margin: ${props => props.margin ? props.margin : "100px auto"};
  display: flex;
  flex-wrap: wrap;
  justify-content:center;
  @media screen and (max-width: 768px) {
    margin: 0 auto;
    padding: 0 24px;
  }
`;
const FormHeaderContainer = styled.div`
  display: block;
  margin-bottom:40px;
`;
const FormHeaderTitleContainer = styled.div<FormHeaderTitleContainerProps>`
  display: block;
  margin: 0 ${props => props.marginHorizontal};
  @media screen and (max-width: 768px) {
      padding: 0;
      margin: 0 10px;
  }
`;

const FormButtonContainer = styled.div`
  display:flex;
  justify-content:center;
  margin-top:56px;
  column-gap:24px;
  @media screen and (max-width: 768px) {
    column-gap:0;
    row-gap:10px;
    margin-top:40px;
    flex-direction:column;
    align-items: center;
  }
`;


const AccordionContainer = styled.div`
  margin: 120px auto 0;
  max-width:792px;
  @media screen and (max-width: 768px) {
    margin: 40px auto 0;
    padding: 0 24px;
  }
`;
const MessageBoxContainer = styled.div`
  max-width:792px;
  margin: 0 auto;
  @media screen and (max-width: 768px) {
  }
`;

const paragraphCss = css`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 180%;
  color: #434343;
  a{
    font-weight: 600;
    font-size: 16px;
  }
  @media screen and (max-width: 768px) {
    font-size: 14px;
    font-weight: 500;
    a{
      font-weight: 500;
      font-size: 14px;
    }
  }
`;
const DeclarationParagraph = css`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22.4px;
  color: #434343;
`;

const container_default_css = css`
  margin-bottom:0px;
`;
const title_default_css = css`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  color: #434343;
  @media screen and (max-width: 768px) {
    width: unset;
    font-size:16px;
  }
`;

const AccordionParagraph = css`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 25.2px;
  color: #434343;  
`;


export interface MessageNoteProps {
  color?: string;
}
export interface ModalContainerProps {
  display?: boolean;
}

export interface FormHeaderTitleContainerProps {
  marginHorizontal: string;
}
export interface FormHeaderContainerProps {
  margin?: string;
  maxWidth?: string;
}




function Eligibility() {
  const history = useHistory();
  const dispatch = useDispatch();
  const campaignDetail = useAvivaSelector(state => state.loading.campaignDetail);
  const basicDetails = useAvivaSelector(state => state.mltcR3Step1.basicDetails);
  const coverage = useAvivaSelector(state => state.mltcR3Step1.coverage);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [backModalVisible, setBackModalVisible] = useState<boolean>(false);
  const [isUOB, setIsUOB] = useState<boolean>(false);
  const [isShowUOB, setIsShowUOB] = useState<boolean>(false);
  const analyticUrlParams = useAvivaSelector(state => state.urlAnalytic.param);
  const [maintenanceModal, setMaintenanceModal] = useState<boolean>(false);
  const isMaintenanceMessageShowing = useAvivaSelector(state => state.loading.isMaintenanceMessageShowing);
  const isMaintenance = useAvivaSelector(state => state.loading.isMaintenance);
  const maintenanceMessage = useAvivaSelector(state => state.loading.maintenanceMessage);


  const paramCC = campaignDetail?.campaignCode ? `?cc=${campaignDetail.campaignCode}` : '';
  const combineParamCC = campaignDetail?.campaignCode ? `&cc=${campaignDetail.campaignCode}` : '';
  const analyticParam = Helpers.getUrlAnalyticParams(paramCC !== "", analyticUrlParams);


  const trackOnLoad = (formName: string): void => {
    const GA = GAAviva.getInstance();
    let { form, cta, page } = GA.digitalData;
    form.name = formName;
    cta = {
      text: "",
      type: ""
    };

    // QB-AA-Tracking fix: step 6 ("Check Eligibility") of the journey.
    page.journeyName = MLTC_R3_JOURNEY_NAME;
    page.stepName = "Check Eligibility";
    page.stepNumber = "6";

    GA.trackPageLoad({ form, cta, page });
  }


  const onNoProcess = () => {
    setBackModalVisible(true);
  }
  const onYesProcess = () => {
    if (isMaintenance) {
      setMaintenanceModal(true);
      return;
    }
    dispatch(updateEligible(true));
    history.push("/mltc/health" + paramCC + analyticParam);
  }

  const onModalYesProcess = (vulnerable: boolean = false) => {
    dispatch(updateEligible(false));
    if (isUOB) {
      // window.open(UOB_CONTACT_URL, "_blank");
      setIsShowUOB(true);
    }
    else {
      history.push(`/mltc/contact-form?vulnerable=${vulnerable}&variant=true` + combineParamCC)
    }
  }

  const onModalNoProcess = () => {
    setBackModalVisible(false);
    // history.goBack();
  }

  const onMaintenanceModalYesProcess = () => {
    let avivaWebsiteUrl = get(window, 'AVIVA_VARIABLE_CONFIG.avivaWebsiteUrl');
    window.open(avivaWebsiteUrl,"_self");
  }
  const onMaintenanceModalNoProcess = () => {
    setMaintenanceModal(false);
  }

  const accordionArgs = {
    theme: themeDefault,
    className: container_default_css,
    title: 'Other things to note before you proceed',
    titleClassName: title_default_css,
    titleFontSize: 16,
    headerPadding: '24px 24px 24px 0',
    isExpanded: true,
    showBottomLine: true,
    showHeaderLine: true,
    bottomLineColor: '#c4c4c4',
    bottomLineThickness: '1px',
    contentMarginLeft: '0px',
    contentMarginRight: '0px',
    bottomLineClassName: 'margin:10px',
  }
  const gotoUOBContact = () => {

    history.push("/mltc/lets-get-started" + paramCC + analyticParam);
    Helpers.clearCached();

    window.open(UOB_CONTACT_URL, "_blank", "noopener noreferrer");
  };

  useEffect(() => {
    if (campaignDetail && campaignDetail?.code === 'LUB1') {
      setIsUOB(true);
    }
    if (basicDetails === null || coverage?.plan === undefined) {
      history.push("/mltc/lets-get-started");
    }

    if (!isLoaded) {
      trackOnLoad("mltc_check_eligibility");
      setIsLoaded(true);
    }

  }, [basicDetails, coverage, history]);

  return (
    <Container>
      
      {isMaintenanceMessageShowing && <MessageBoxContainer>
        <MaintenanceMessageBox>
          <Text theme={themeDefault} className={paragraphCss}>{maintenanceMessage}</Text>
        </MaintenanceMessageBox>
      </MessageBoxContainer>}

      <FormContainer maxWidth={'588px'} margin={"0px auto 0"}>
        <FormHeaderContainer>
          <FormHeaderTitleContainer marginHorizontal={"80px"}>
            <Text theme={themeDefault} align={"center"} className={HeaderTitleCss}>
              Before we proceed, do you fulfill all of the following?
            </Text>
          </FormHeaderTitleContainer>
        </FormHeaderContainer>

        <DeclarationBulletsContainer>
          <Bullet><Text theme={themeDefault} className={DeclarationParagraph}>I am between 30 - 62 years old.</Text></Bullet>
          <Bullet><Text theme={themeDefault} className={DeclarationParagraph}>I am proficient in both spoken and written English.</Text></Bullet>
          <Bullet><Text theme={themeDefault} className={DeclarationParagraph}>I have attained at least a GCE N-Level or O-Level certification, or equivalent academic qualification.</Text></Bullet>
          <Bullet><Text theme={themeDefault} className={DeclarationParagraph}>I am purchasing the plan without any advice from a financial adviser representative and I take responsibility to ensure that this plan suits my needs.</Text></Bullet>
          <Bullet><Text theme={themeDefault} className={DeclarationParagraph}>I am a Singapore Resident and I have resided in Singapore for more than 183 days in the last 12 months.</Text></Bullet>
        </DeclarationBulletsContainer>

        <FormButtonContainer>
          <Button onClick={onNoProcess} width={"282px"} variant={'secondary'} theme={themeDefault} label={"No, I don’t"}></Button>
          <Button onClick={onYesProcess} width={"282px"} variant={'default'} theme={themeDefault} label={"Yes, I do"}></Button>
        </FormButtonContainer>
      </FormContainer>

      <Modal show={backModalVisible}>
        <BackModal onYesClick={() => onModalYesProcess(true)} onNoClick={onModalNoProcess} />
      </Modal>
      <Modal show={maintenanceModal && isMaintenance}>
        <MaintenanceModal onYesClick={() => onMaintenanceModalYesProcess()} onNoClick={onMaintenanceModalNoProcess} />
      </Modal>

      <AccordionContainer>
        <Accordion {...accordionArgs}>
          <div style={{ paddingBottom: "20px" }}>
            <Bullet><Text theme={themeDefault} className={AccordionParagraph}>You may ask us to explain the product features to you.</Text></Bullet>
            <Bullet><Text theme={themeDefault} className={AccordionParagraph}>You may wish to separately seek advice on the suitability of the long term care policy.</Text></Bullet>
            <Bullet><Text theme={themeDefault} className={AccordionParagraph}>In the event that you choose not to seek advice on the suitability of the long term care  policy, you should consider if the long term care  policy is suitable for your financial circumstances and needs.</Text></Bullet>
          </div>
        </Accordion>
      </AccordionContainer>

      <Modal show={isShowUOB} onClose={() => { setIsShowUOB(false) }}>
        <Text margin={'0px 0 30px'}>You will be redirected to our appointed intermediary - United Overseas Bank Limited (“UOB”) site to submit the contact me form.</Text>
        <Button margin="0 0 20px" label="Proceed" onClick={gotoUOBContact} />
        <Button variant="secondary" label="Cancel" margin={0} onClick={() => { setIsShowUOB(false) }} />
      </Modal>

      <BottomSheet />
    </Container>
  )
}

export default Eligibility